import React, { useState } from 'react';
import { Play, Square, Download, Volume2 } from 'lucide-react';
import { zipSync } from 'fflate';

const save = (blob, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 4000); };
const slug = (s) => String(s || 'clip').toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').slice(0, 40);

export const TransportPanel = ({ lab }) => {
  const { current, playing, frac, speed, mode, clips } = lab;
  const [media, setMedia] = useState('video');
  const [scope, setScope] = useState('last');
  const r = lab.responseOf(current);
  const file = (c) => { const cap = c[`cap_${mode}`]; return cap ? cap[media] : null; };
  const ext = media === 'video' ? 'webm' : 'webm';

  const download = async () => {
    if (scope === 'last') { const b = current && file(current); if (b) save(b, `vocalfitness-${slug(current.label)}-${mode}.${ext}`); return; }
    const files = {};
    for (const c of clips) {
      const b = file(c); if (!b) continue;
      files[`${c.id}-${slug(c.label)}-${mode}.${ext}`] = new Uint8Array(await b.arrayBuffer());
    }
    if (Object.keys(files).length) save(new Blob([zipSync(files)], { type: 'application/zip' }), `vocalfitness-lab-${media}.zip`);
  };
  const canDl = scope === 'last' ? !!(current && file(current)) : clips.some(file);

  return (
    <div className="rounded-2xl border border-cyan-500/20 bg-slate-900/60 p-4 space-y-3" data-testid="samuel-transport">
      <div className="flex items-center gap-2">
        <button onClick={() => (playing ? lab.stopAll() : lab.playImitation(current, mode, frac < 0.99 ? frac : 0))} disabled={!r}
          data-testid="play-imitation" className="flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-400 text-slate-950 text-sm font-bold disabled:opacity-40">
          {playing ? <Square className="w-4 h-4" /> : <Play className="w-4 h-4" />} {playing ? 'Stop' : 'Riproduci imitazione'}
        </button>
        <input type="range" min="0" max="1" step="0.001" value={frac} disabled={!r} data-testid="scrub-slider"
          onChange={(e) => lab.scrubTo(Number(e.target.value))} onPointerUp={lab.endScrub} onKeyUp={lab.endScrub}
          className="flex-1 accent-amber-400 disabled:opacity-40" title="Scorri l’audio: la bocca si ferma su ogni istante" />
        <span className="text-[11px] font-mono text-cyan-200/80 w-12 text-right" data-testid="scrub-time">{r ? (frac * r.duration_s).toFixed(2) : '0.00'}s</span>
      </div>
      <div className="flex flex-wrap items-center gap-3 text-xs">
        <button onClick={lab.playOriginal} disabled={!current?.url} data-testid="play-original" className="flex items-center gap-1.5 text-cyan-200 hover:text-white disabled:opacity-40">
          <Volume2 className="w-3.5 h-3.5" /> Ascolta l’originale
        </button>
        <label className="flex items-center gap-2 text-cyan-200/80">Velocità ×{speed.toFixed(2)}
          <input type="range" min="0.25" max="1.5" step="0.05" value={speed} onChange={(e) => lab.setSpeed(Number(e.target.value))} className="w-28 accent-cyan-400" data-testid="speed-slider" />
        </label>
        <span className="ml-auto text-slate-400" data-testid="current-clip-label">{current ? `${current.label}${current.transcript ? ` · “${current.transcript}”` : ''}` : 'Nessuna clip'}</span>
      </div>
      <div className="flex flex-wrap items-center gap-2 pt-2 border-t border-slate-800 text-xs">
        <Download className="w-3.5 h-3.5 text-cyan-300" />
        {['video', 'audio'].map((m) => <button key={m} onClick={() => setMedia(m)} data-testid={`dl-media-${m}`} className={`px-2 py-1 rounded ${media === m ? 'bg-cyan-500/30 text-white' : 'text-cyan-200/70'}`}>{m === 'video' ? 'Video' : 'Audio'}</button>)}
        <span className="text-slate-600">·</span>
        {[['last', 'Ultima clip'], ['all', 'Tutte (zip)']].map(([k, l]) => <button key={k} onClick={() => setScope(k)} data-testid={`dl-scope-${k}`} className={`px-2 py-1 rounded ${scope === k ? 'bg-cyan-500/30 text-white' : 'text-cyan-200/70'}`}>{l}</button>)}
        <button onClick={download} disabled={!canDl} data-testid="dl-button" className="ml-auto px-3 py-1 rounded-lg bg-slate-800 text-cyan-100 font-semibold disabled:opacity-40">Scarica</button>
      </div>
      {clips.length > 1 && (
        <div className="flex flex-wrap gap-1" data-testid="clip-history">
          {clips.slice().reverse().map((c) => (
            <button key={c.id} onClick={() => lab.setCurrentId(c.id)} className={`px-2 py-0.5 rounded text-[11px] ${c.id === lab.currentId ? 'bg-amber-400 text-slate-950' : 'bg-slate-800 text-slate-300'}`} data-testid={`history-${c.id}`}>{c.label}</button>
          ))}
        </div>
      )}
    </div>
  );
};
